import { createSlice } from "@reduxjs/toolkit";

export const notificationUpdateSlice = createSlice({
  name: "notificationUpdate",
  initialState: {
    getNotificationUpdateResult: false,
    getNotificationUpdateLoading: false,
    getNotificationUpdateError: false,
    addNotificationUpdateResult: false,
    addNotificationUpdateLoading: false,
    deleteNotificationUpdateResult: false,
  },
  reducers: {
    notificationUpdateReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_NOTIFICATIONUPDATE":
          return {
            ...state,
            getNotificationUpdateResult: payload.data,
            getNotificationUpdateLoading: payload.loading,
            getNotificationUpdateError: payload.error,
          };
        case "ADD_NOTIFICATIONUPDATE":
          return {
            ...state,
            addNotificationUpdateResult: payload.data,
            addNotificationUpdateLoading: payload.loading,
          };
        case "DELETE_NOTIFICATIONUPDATE":
          return {
            ...state,
            deleteNotificationUpdateResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { notificationUpdateReducers } = notificationUpdateSlice.actions;

export default notificationUpdateSlice.reducer;
